import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, getApi } from 'services/rotasp/api';
import { ReducerActionRotaSP } from 'store/modules/types';
import { cleanEmpty } from 'utils/genericFunctions';
import { PATH_SGU_DOMINIOS_API } from '../../../../../../../services/rotasp/path';
import {
	ConsultarNaturalidadesIntegradorRequest,
	ConsultarNaturalidadesRequest,
	Types,
} from './types';
import {
	consultarNaturalidadesSuccess,
	consultarNaturalidadesFailure,
} from './actions';

// UTILS

function* consultarNaturalidades(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultarNaturalidadesRequest } = request;

	let body: ConsultarNaturalidadesIntegradorRequest = {
		page: payload.current ? payload.current - 1 : undefined,
		size: payload.limite,
		id: (payload.id && Number(payload.id)) || undefined,
		digito: (payload.digito && Number(payload.digito)) || undefined,
		descricao: (payload.descricao && payload.descricao) || undefined,
		uf: payload.uf?.toString() || undefined,
		sigla: payload.sigla,
	};

	body = cleanEmpty(body) as ConsultarNaturalidadesIntegradorRequest;

	if (body.digito === 0) {
		delete body.digito;
	}

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_DOMINIOS_API,
		`naturalidades`,
		body,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultarNaturalidadesSuccess(response));
	} else {
		yield put(consultarNaturalidadesFailure());
	}
}

export default all([
	takeLatest(Types.CONSULTAR_NATURALIDADES_REQUEST, consultarNaturalidades),
]);
